// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4682":"11f22a4a","7611":"43ef9ecb"}[chunkId] + ".chunk.css";
};